/**
 * Using this as a default in a switch statement will give us enum type safety
 * ensuring all possible cases are handled. That way if we ever add a value to
 * an enum, the compiler will automatically require that new case to be handled
 * everywhere.
 * Source: https://stackoverflow.com/a/52913382/684353
 */
export default class UnreachableCaseError extends Error {
  constructor(val: never) {
    super(`Unreachable case: ${val}`)
  }
}
